import IconAdd from "../../components/icons/IconAdd";
import IconDelete from "../../components/icons/IconDelete";
import IconAddLink from "../../components/icons/IconAddLink";
import IconPlugIn from "../../components/icons/IconPlugIn";
import useConnectorForm from "./useConnectorForm";
import QuestionText from "./QuestionText";
import ConnectorForm from "./ConnectorForm";
import ConnectorList from "./ConnectorList";
import BotErrorBadge from "../../components/botHealth/BotErrorBadge";

export default function QuestionNode({
    item,
    estimationGroups,
    stages,
    errors,
    choseNextQuestionMode,
    setChoseNextQuestionMode,
    gotUpdatedQuestion,
}) {
    const form = useConnectorForm({ item, choseNextQuestionMode, setChoseNextQuestionMode, gotUpdatedQuestion });

    return (
        <div className="question-plate">
            {form.isVisibleAddConnectorOptions ? (
                <ConnectorForm form={form} estimationGroups={estimationGroups} stages={stages} />
            ) : (
                ""
            )}

            <ConnectorList item={item} form={form} />

            <div className="functional-panel">
                <div className="functional-panelbutton left" onMouseDown={(e) => e.stopPropagation()} onClick={form.deleteQuestionHandler}>
                    <IconDelete fillColor="icon-red" style={{ width: 25, height: 25 }} />
                </div>

                <div style={{ display: "flex" }}>
                    <div
                        className="functional-panelbutton"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={form.showOptionsAddAnswerConnector}
                    >
                        <IconAdd />
                    </div>

                    <BotErrorBadge errors={errors} />
                </div>
            </div>

            <QuestionText item={item} onSaved={gotUpdatedQuestion} />

            {choseNextQuestionMode && choseNextQuestionMode.questionIdFrom != item.id ? (
                <div
                    className={"question-plate-choser " + (item.id == choseNextQuestionMode.questionIdNext ? "question-chosen" : "")}
                    onClick={form.addLinkHandler}
                >
                    {choseNextQuestionMode.questionIdNext != item.id ? (
                        <IconAddLink fillColor="icon-blue question-plate-choser-icon " />
                    ) : (
                        <IconPlugIn fillColor="icon-green question-plate-choser-icon" />
                    )}
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
